import * as Effects from "redux-saga/effects";
import { ProjectActions } from "../reducers/project/actionsNames";
import { getSelectedAttributes } from "../reducers/project/selectors";

function* fetchContent() {
    const selected = yield Effects.select(getSelectedAttributes);

    const response = yield fetch(process.env.REACT_APP_API_URL + "/project/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
            date: new Date().getTime(),
            components: selected,
        }),
    });

    let project = yield response.json();

    yield Effects.put({
        type: ProjectActions.InsertProject,
        project: {
            ...project,
            components: project.components.map((c) => ({ ...c, count: 1 })),
        },
    });
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.CreateProject, fetchContent);
}
